import { getUIDescription } from "../components/SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";
import { PRC_WELL } from "./PRC_WELL";
import axios from "./axiosInstance";

const uint16ToInt16 = (n) => {
  return n > 0x7FFF ? n - 0x10000 : n;
}

export const getWellsFromAPI = async (unitId) => {
  try {
    const [plungerRes, engineRes] = await Promise.all([
      axios.get(`${process.env.REACT_APP_API_GATEAWAY}/iot/plungers/${unitId}`),
      axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${unitId}`,
      ),
    ]);
    return {
      type: engineRes?.data?.type,
      response: plungerRes.data.data.response,
    };
  } catch (err) {
    console.error("Failed to get plunger data:", err);
    return null;
  }
};

export const getWellConfig = async (wellId) => {
  const wellConfigs = {
    1: {
      ID: 1, //
      STATE: "42479", //
      TUBING: "40510", //
      CASING: "40509", //
      FLOW_RATE: "40511", //
      OPEN_TIME: ["42275", "42276", "42277"], //
      AF_TIME: ["42278", "42279", "42280"], //
      SHUTIN_TIME: ["42281", "42282", "42283"], //
      MD_TIME: ["42284", "42285", "42286"], //
      CUR_RUNTIME: ["42451", "42455", "42459"], //
      PRV_RUNTIME: ["42509", "42510", "42511"], //
      AVG_RUNTIME: ["42500", "42501", "42502"], //
      MIN_RUNTIME: ["42503", "42504", "42505"], //
      MAX_RUNTIME: ["42506", "42507", "42508"], //
      WELL_ARRV: "42836", //
      WELL_MISR: "42848", //
      OVER_RUN: "42840", //
      UNDER_RUN: "42844", //
      INC_DEC: "42856", //
      RUN1: ["42509", "42510", "42511"], //
      RUN2: ["42512", "42513", "42514"], //
      RUN3: ["42515", "42516", "42517"], //
      RUN4: ["42518", "42519", "42520"], //
      RUN5: ["42521", "42522", "42523"], //
      RUN6: ["42524", "42525", "42526"], //
      RUN7: ["42527", "42528", "42529"], //
      RUN8: ["42530", "42531", "42532"], //
      RUN9: ["42533", "42534", "42535"], //
      RUN10: ["42536", "42537", "42538"], //
      RUN11: ["42539", "42540", "42541"], //
      RUN12: ["42542", "42543", "42544"], //
      RUN13: ["42545", "42546", "42547"], //
      RUN14: ["42548", "42549", "42550"], //
      RUN15: ["42551", "42552", "42553"], //
      RUN16: ["42554", "42555", "42556"], //
      RUN17: ["42557", "42558", "42559"], //
      RUN18: ["42560", "42561", "42562"], //
      RUN19: ["42563", "42564", "42565"], //
      RUN20: ["42566", "42567", "42568"], //
      AVG_HELDTIMES: ["43451", "43452", "43453"], //
      MIN_HELDTIMES: ["43454", "43455", "43456"], //
      MAX_HELDTIMES: ["43457", "43458", "43459"], //
      HELD1: ["43460", "43461", "43462"], //
      HELD2: ["43463", "43464", "43465"], //
      HELD3: ["43466", "43467", "43468"], //
      HELD4: ["43469", "43470", "43471"], //
      HELD5: ["43472", "43473", "43474"], //
      HELD6: ["43475", "43476", "43477"], //
      HELD7: ["43478", "43479", "43480"], //
      HELD8: ["43481", "43482", "43483"], //
      HELD9: ["43484", "43485", "43486"], //
      HELD10: ["43487", "43488", "43489"], //
      HELD11: ["43490", "43491", "43492"], //
      HELD12: ["43493", "43494", "43495"], //
      HELD13: ["43496", "43497", "43498"], //
      HELD14: ["43499", "43500", "43501"], //
      HELD15: ["43502", "43503", "43504"], //
      HELD16: ["43505", "43506", "43507"], //
      HELD17: ["43508", "43509", "43510"], //
      HELD18: ["43511", "43512", "43513"], //
      HELD19: ["43514", "43515", "43516"], //
      HELD20: ["43517", "43518", "43519"], //
      WELL_DEPTH: "42148", //
      MAX_MISSED_RUN: "42147", //
      CASING_INJ_SETPOINT: "44115", //
      CASING_INJ_DEADBAND: "44119", //
      CASING_INJ_HI_SETPOINT: "44131", //
      CASING_INJ_HI_DEADBAND: "44135", //
      OVERWATCH: "42407", //
      DET_PLG_FAIL: "42411", //
      DET_GHOST_ARR: "42447", //
      SHUTIN_PLG_FALL: "42415", //
      CASING_RISE: "42419", //
      CRIT_FLOW_RATE: "42423", //
      TUBING_CASING: "42427", //
      OVER_RUN_SETPOINT: ["42290", "42291", "42292"], //
      OVER_RUN_TIMER: ["42293", "42294", "42295"], //
      UNDER_RUN_SETPOINT: ["42296", "42297", "42298"], //
      UNDER_RUN_TIMER: ["42299", "42300", "42301"], //
      MAX_UNDER_RUN: "42149", //
      UNDER_RUN_DEC: "42150", //
      MAX_OVER_RUN: "42151", //
      OVER_RUN_INC: "42152", //
      MAX_INC_DEC: "42153",
      MIN_FLOW_PID: "42868", //
      MAX_FLOW_PID: "42872", //
      MIN_CASING_PRS: "42880", //
      MAX_CASING_PRS: "42884", //
      COMP_SD: "42860", //
      MAND_SHUTIN_SD: "42864", //
      RESET_FAULT_CLEAR: "40094",
      START_PLG_LIFT: "40093",
      DISABLE_WELL: "42487",
      AUTO_SP: "43808", // == FLOW RATE AUTOMATIC SP
      CASING_ACTUAL: "40509", // NOT WRITABLE
      CASING_TIME_SAMPLE: "44027", // NOT WRITABLE
      SAMPLE_TIME: "44035", //
      SAMPLE_DEADBAND: "44023",
      SETPOINT_INC_VAL: "44019", //
      SETPOINT_DEC_VAL: "44015", //
      MIN_FLOW_RATE: "41719", //
      MAX_FLOW_RATE: "41718", //
      FLOW_RATE_DEADBAND: "43809", //
      TUBING_CASING_SP: "42157", //
      TUBING_CASING_DEBOUNCE: "42386", //
      MAX_SHUTIN_RESET: "42443",
      PLG_FALL_TIMER: ["42287", "42288", "42289"], //
      CASING_RISE_SP: "42156", //
      CASING_RISE_DEBOUNCE: "42385",
      CASING_PID_AUTO_SP: "43792", //
      CASING_PID_DEADBAND_SP: "43793", //
      CRITICAL_FLOW_RATE_SP: "42154", //
      CRITICAL_FLOW_RATE_DEADBAND: "42155", //
      CRITICAL_FLOW_RATE_DEBOUNCE: "42384", //
      MAX_AFTERFLOW_RESET: "42439", //
      ROC_ENABLE_DISABLE: "_42431",
      ROC_OPEN_STATE: "_42888",
      ROC_AF_STATE: "_42889",
      ROC_SHUTIN_STATE: "_42890",
      ROC_MANDATORY_SHUTIN_STATE: "_42891",
      PLG_SD_SP_CASING_PRESURE: ["_41079", "_41080", "_41081", "_41082"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_TUBING_PRESURE: ["_41083", "_41084", "_41085", "_41086"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_FLOWRATE_PRESURE: ["_41087", "_41088", "_41089", "_41090"], // LOLO - LO - HI - HIHI
      RESET_RUNTIMES: "44139",
      PROP_VALVE_CONTROL: "_43979",
      PROP_VALVE_POS: "_42403",
      PROP_MIN_OUTPUT: "_43984",
      PROP_MAX_OUTPUT: "_43985",
      PROP_MANUAL_SP: "_44039",
    },
    2: {
      ID: 2,
      STATE: "42480",
      TUBING: "40516",
      CASING: "40515",
      FLOW_RATE: "40517",
      OPEN_TIME: ["42302", "42303", "42304"],
      AF_TIME: ["42305", "42306", "42307"],
      SHUTIN_TIME: ["42308", "42309", "42310"],
      MD_TIME: ["42311", "42312", "42313"],
      CUR_RUNTIME: ["42452", "42456", "42460"],
      PRV_RUNTIME: ["42593", "42594", "42595"],
      AVG_RUNTIME: ["42584", "42585", "42586"],
      MIN_RUNTIME: ["42587", "42588", "42589"],
      MAX_RUNTIME: ["42590", "42591", "42592"],
      WELL_ARRV: "42837",
      WELL_MISR: "42849",
      OVER_RUN: "42841",
      UNDER_RUN: "42845",
      INC_DEC: "42857",
      RUN1: ["42593", "42594", "42595"],
      RUN2: ["42596", "42597", "42598"], //
      RUN3: ["42599", "42600", "42601"], //
      RUN4: ["42602", "42603", "42604"], //
      RUN5: ["42605", "42606", "42607"], //
      RUN6: ["42608", "42609", "42610"], //
      RUN7: ["42611", "42612", "42613"], //
      RUN8: ["42614", "42615", "42616"], //
      RUN9: ["42617", "42618", "42619"], //
      RUN10: ["42620", "42621", "42622"], //
      RUN11: ["42623", "42624", "42625"], //
      RUN12: ["42626", "42627", "42628"], //
      RUN13: ["42629", "42630", "42631"], //
      RUN14: ["42632", "42633", "42634"], //
      RUN15: ["42635", "42636", "42637"], //
      RUN16: ["42638", "42639", "42640"], //
      RUN17: ["42641", "42642", "42643"], //
      RUN18: ["42644", "42645", "42646"], //
      RUN19: ["42647", "42648", "42649"], //
      RUN20: ["42650", "42651", "42652"], //
      AVG_HELDTIMES: ["43535", "43536", "43537"],
      MIN_HELDTIMES: ["43538", "43539", "43540"],
      MAX_HELDTIMES: ["43541", "43542", "43543"],
      HELD1: ["43544", "43545", "43546"], //
      HELD2: ["43547", "43548", "43549"], //
      HELD3: ["43550", "43551", "43552"], //
      HELD4: ["43553", "43554", "43555"], //
      HELD5: ["43556", "43557", "43558"], //
      HELD6: ["43559", "43560", "43561"], //
      HELD7: ["43562", "43563", "43564"], //
      HELD8: ["43565", "43566", "43567"], //
      HELD9: ["43568", "43569", "43570"], //
      HELD10: ["43571", "43572", "43573"], //
      HELD11: ["43574", "43575", "43576"], //
      HELD12: ["43577", "43578", "43579"], //
      HELD13: ["43580", "43581", "43582"], //
      HELD14: ["43583", "43584", "43585"], //
      HELD15: ["43586", "43587", "43588"], //
      HELD16: ["43589", "43590", "43591"], //
      HELD17: ["43592", "43593", "43594"], //
      HELD18: ["43595", "43596", "43597"], //
      HELD19: ["43598", "43599", "43600"], //
      HELD20: ["43601", "43602", "43603"], //
      WELL_DEPTH: "42159",
      MAX_MISSED_RUN: "42158",
      CASING_INJ_SETPOINT: "44116",
      CASING_INJ_DEADBAND: "44120",
      CASING_INJ_HI_SETPOINT: "44132",
      CASING_INJ_HI_DEADBAND: "44136",
      OVERWATCH: "42408",
      DET_PLG_FAIL: "42412",
      DET_GHOST_ARR: "42448",
      SHUTIN_PLG_FALL: "42416",
      CASING_RISE: "42420",
      CRIT_FLOW_RATE: "42424",
      TUBING_CASING: "42428",
      OVER_RUN_SETPOINT: ["42317", "42318", "42319"],
      OVER_RUN_TIMER: ["42320", "42321", "42322"],
      UNDER_RUN_SETPOINT: ["42323", "42324", "42325"],
      UNDER_RUN_TIMER: ["42326", "42327", "42328"],
      MAX_UNDER_RUN: "42160",
      UNDER_RUN_DEC: "42161",
      MAX_OVER_RUN: "42162",
      OVER_RUN_INC: "42163",
      MAX_INC_DEC: "42164",
      MIN_FLOW_PID: "42869",
      MAX_FLOW_PID: "42873",
      MIN_CASING_PRS: "42881", //
      MAX_CASING_PRS: "42885", //
      COMP_SD: "42861",
      MAND_SHUTIN_SD: "42865",
      RESET_FAULT_CLEAR: "40094",
      START_PLG_LIFT: "40093",
      DISABLE_WELL: "42488",
      AUTO_SP: "43856", // == FLOW RATE AUTOMATIC SP
      CASING_ACTUAL: "40515", //NOT WRITABLE
      CASING_TIME_SAMPLE: "44028", //NOT WRITABLE
      SAMPLE_TIME: "44036",
      SAMPLE_DEADBAND: "44024",
      SETPOINT_INC_VAL: "44020",
      SETPOINT_DEC_VAL: "44016",
      MIN_FLOW_RATE: "41721",
      MAX_FLOW_RATE: "41720",
      FLOW_RATE_DEADBAND: "43857",
      TUBING_CASING_SP: "42168",
      TUBING_CASING_DEBOUNCE: "42390",
      MAX_SHUTIN_RESET: "42444",
      PLG_FALL_TIMER: ["42314", "42315", "42316"],
      CASING_RISE_SP: "42167",
      CASING_RISE_DEBOUNCE: "42389",
      CASING_PID_AUTO_SP: "43840",
      CASING_PID_DEADBAND_SP: "43841",
      CRITICAL_FLOW_RATE_SP: "42165",
      CRITICAL_FLOW_RATE_DEADBAND: "42166",
      CRITICAL_FLOW_RATE_DEBOUNCE: "42388",
      MAX_AFTERFLOW_RESET: "42440",
      PLG_SD_SP_CASING_PRESURE: ["_41103", "_41104", "_41105", "_41106"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_TUBING_PRESURE: ["_41107", "_41108", "_41109", "_41110"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_FLOWRATE_PRESURE: ["_41111", "_41112", "_41113", "_41114"], // LOLO - LO - HI - HIHI
      RESET_RUNTIMES: "44140",
      PROP_VALVE_CONTROL: "_43986",
      PROP_VALVE_POS: "_42404",
      PROP_MIN_OUTPUT: "_43991",
      PROP_MAX_OUTPUT: "_43992",
      PROP_MANUAL_SP: "_44040",
    },
    3: {
      ID: 3,
      STATE: "42481",
      TUBING: "40519",
      CASING: "40518",
      FLOW_RATE: "40520",
      OPEN_TIME: ["42329", "42330", "42331"],
      AF_TIME: ["42332", "42333", "42334"],
      SHUTIN_TIME: ["42335", "42336", "42337"],
      MD_TIME: ["42338", "42339", "42340"],
      CUR_RUNTIME: ["42453", "42457", "42461"],
      PRV_RUNTIME: ["42677", "42678", "42679"],
      AVG_RUNTIME: ["42668", "42669", "42670"],
      MIN_RUNTIME: ["42671", "42672", "42673"],
      MAX_RUNTIME: ["42674", "42675", "42676"],
      WELL_ARRV: "42838",
      WELL_MISR: "42850",
      OVER_RUN: "42842",
      UNDER_RUN: "42846",
      INC_DEC: "42858",
      RUN1: ["42677", "42678", "42679"],
      RUN2: ["42680", "42681", "42682"],
      RUN3: ["42683", "42684", "42685"],
      RUN4: ["42686", "42687", "42688"],
      RUN5: ["42689", "42690", "42691"],
      RUN6: ["42692", "42693", "42694"],
      RUN7: ["42695", "42696", "42697"],
      RUN8: ["42698", "42699", "42700"],
      RUN9: ["42701", "42702", "42703"],
      RUN10: ["42704", "42705", "42706"],
      RUN11: ["42707", "42708", "42709"],
      RUN12: ["42710", "42711", "42712"],
      RUN13: ["42713", "42714", "42715"],
      RUN14: ["42716", "42717", "42718"],
      RUN15: ["42719", "42720", "42721"],
      RUN16: ["42722", "42723", "42724"],
      RUN17: ["42725", "42726", "42727"],
      RUN18: ["42728", "42729", "42730"],
      RUN19: ["42731", "42732", "42733"],
      RUN20: ["42734", "42735", "42736"],
      AVG_HELDTIMES: ["43619", "43620", "43621"],
      MIN_HELDTIMES: ["43622", "43623", "43624"],
      MAX_HELDTIMES: ["43625", "43626", "43627"],
      HELD1: ["43628", "43629", "43630"],
      HELD2: ["43631", "43632", "43633"],
      HELD3: ["43634", "43635", "43636"],
      HELD4: ["43637", "43638", "43639"],
      HELD5: ["43640", "43641", "43642"],
      HELD6: ["43643", "43644", "43645"],
      HELD7: ["43646", "43647", "43648"],
      HELD8: ["43649", "43650", "43651"],
      HELD9: ["43652", "43653", "43654"],
      HELD10: ["43655", "43656", "43657"],
      HELD11: ["43658", "43659", "43660"],
      HELD12: ["43661", "43662", "43663"],
      HELD13: ["43664", "43665", "43666"],
      HELD14: ["43667", "43668", "43669"],
      HELD15: ["43670", "43671", "43672"],
      HELD16: ["43673", "43674", "43675"],
      HELD17: ["43676", "43677", "43678"],
      HELD18: ["43679", "43680", "43681"],
      HELD19: ["43682", "43683", "43684"],
      HELD20: ["43685", "43686", "43687"],
      WELL_DEPTH: "42170",
      MAX_MISSED_RUN: "42169",
      CASING_INJ_SETPOINT: "44117",
      CASING_INJ_DEADBAND: "44121",
      CASING_INJ_HI_SETPOINT: "44133",
      CASING_INJ_HI_DEADBAND: "44137",
      OVERWATCH: "42409",
      DET_PLG_FAIL: "42413",
      DET_GHOST_ARR: "42449",
      SHUTIN_PLG_FALL: "42417",
      CASING_RISE: "42421",
      CRIT_FLOW_RATE: "42425",
      TUBING_CASING: "42429",
      OVER_RUN_SETPOINT: ["42344", "42345", "42346"],
      OVER_RUN_TIMER: ["42347", "42348", "42349"],
      UNDER_RUN_SETPOINT: ["42350", "42351", "42352"],
      UNDER_RUN_TIMER: ["42353", "42354", "42355"],
      MAX_UNDER_RUN: "42171",
      UNDER_RUN_DEC: "42172",
      MAX_OVER_RUN: "42173",
      OVER_RUN_INC: "42174",
      MAX_INC_DEC: "42175",
      MIN_FLOW_PID: "42870",
      MAX_FLOW_PID: "42874",
      MIN_CASING_PRS: "42882", //
      MAX_CASING_PRS: "42886", //
      COMP_SD: "42862",
      MAND_SHUTIN_SD: "42866",
      RESET_FAULT_CLEAR: "40094",
      START_PLG_LIFT: "40093",
      DISABLE_WELL: "42489",
      AUTO_SP: "43904", // == FLOW RATE AUTOMATIC SP
      CASING_ACTUAL: "40518", //NOT WRITABLE
      CASING_TIME_SAMPLE: "44029", //NOT WRITABLE
      SAMPLE_TIME: "44037",
      SAMPLE_DEADBAND: "44025",
      SETPOINT_INC_VAL: "44021",
      SETPOINT_DEC_VAL: "44017",
      MIN_FLOW_RATE: "41723",
      MAX_FLOW_RATE: "41722",
      // == FLOW RATE AUTOMATIC SP
      FLOW_RATE_DEADBAND: "43905",
      TUBING_CASING_SP: "42179", //"42719" #CHANGED BY RAYMOND ON OCT21, 2024
      TUBING_CASING_DEBOUNCE: "42394",
      MAX_SHUTIN_RESET: "42445",
      PLG_FALL_TIMER: ["42341", "42342", "42343"],
      CASING_RISE_SP: "42178",
      CASING_RISE_DEBOUNCE: "42393",
      CASING_PID_AUTO_SP: "43888",
      CASING_PID_DEADBAND_SP: "43889",
      CRITICAL_FLOW_RATE_SP: "42176",
      CRITICAL_FLOW_RATE_DEADBAND: "42177",
      CRITICAL_FLOW_RATE_DEBOUNCE: "42392",
      MAX_AFTERFLOW_RESET: "42441",
      PLG_SD_SP_CASING_PRESURE: ["_41115", "_41116", "_41117", "_41118"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_TUBING_PRESURE: ["_41119", "_41120", "_41121", "_41122"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_FLOWRATE_PRESURE: ["_41123", "_41124", "_41125", "_41126"], // LOLO - LO - HI - HIHI
      RESET_RUNTIMES: "44141",
      PROP_VALVE_CONTROL: "_43993",
      PROP_VALVE_POS: "_42405",
      PROP_MIN_OUTPUT: "_43998",
      PROP_MAX_OUTPUT: "_43999",
      PROP_MANUAL_SP: "_44041",
    },
    4: {
      ID: 4,
      STATE: "42482",
      TUBING: "40522",
      CASING: "40521",
      FLOW_RATE: "40523",
      OPEN_TIME: ["42356", "42357", "42358"],
      AF_TIME: ["42359", "42360", "42361"],
      SHUTIN_TIME: ["42362", "42363", "42364"],
      MD_TIME: ["42365", "42366", "42367"],
      CUR_RUNTIME: ["42454", "42458", "42462"],
      PRV_RUNTIME: ["42761", "42762", "42763"],
      AVG_RUNTIME: ["42752", "42753", "42754"],
      MIN_RUNTIME: ["42755", "42756", "42757"],
      MAX_RUNTIME: ["42758", "42759", "42760"],
      WELL_ARRV: "42839",
      WELL_MISR: "42851",
      OVER_RUN: "42843",
      UNDER_RUN: "42847",
      INC_DEC: "42859",
      RUN1: ["42761", "42762", "42763"],
      RUN2: ["42764", "42765", "42766"],
      RUN3: ["42767", "42768", "42769"],
      RUN4: ["42770", "42771", "42772"],
      RUN5: ["42773", "42774", "42775"],
      RUN6: ["42776", "42777", "42778"],
      RUN7: ["42779", "42780", "42781"],
      RUN8: ["42782", "42783", "42784"],
      RUN9: ["42785", "42786", "42787"],
      RUN10: ["42788", "42789", "42790"],
      RUN11: ["42791", "42792", "42793"],
      RUN12: ["42794", "42795", "42796"],
      RUN13: ["42797", "42798", "42799"],
      RUN14: ["42800", "42801", "42802"],
      RUN15: ["42803", "42804", "42805"],
      RUN16: ["42806", "42807", "42808"],
      RUN17: ["42809", "42810", "42811"],
      RUN18: ["42812", "42813", "42814"],
      RUN19: ["42815", "42816", "42817"],
      RUN20: ["42818", "42819", "42820"],
      AVG_HELDTIMES: ["43703", "43704", "43705"],
      MIN_HELDTIMES: ["43706", "43707", "43708"],
      MAX_HELDTIMES: ["43709", "43710", "43711"],
      HELD1: ["43712", "43713", "43714"],
      HELD2: ["43715", "43716", "43717"],
      HELD3: ["43718", "43719", "43720"],
      HELD4: ["43721", "43722", "43723"],
      HELD5: ["43724", "43725", "43726"],
      HELD6: ["43727", "43728", "43729"],
      HELD7: ["43730", "43731", "43732"],
      HELD8: ["43733", "43734", "43735"],
      HELD9: ["43736", "43737", "43738"],
      HELD10: ["43739", "43740", "43741"],
      HELD11: ["43742", "43743", "43744"],
      HELD12: ["43745", "43746", "43747"],
      HELD13: ["43748", "43749", "43750"],
      HELD14: ["43751", "43752", "43753"],
      HELD15: ["43754", "43755", "43756"],
      HELD16: ["43757", "43758", "43759"],
      HELD17: ["43760", "43761", "43762"],
      HELD18: ["43763", "43764", "43765"],
      HELD19: ["43766", "43767", "43768"],
      HELD20: ["43769", "43770", "43771"],
      WELL_DEPTH: "42181",
      MAX_MISSED_RUN: "42180",
      CASING_INJ_SETPOINT: "44118",
      CASING_INJ_DEADBAND: "44122",
      CASING_INJ_HI_SETPOINT: "44134",
      CASING_INJ_HI_DEADBAND: "44138",
      OVERWATCH: "42410",
      DET_PLG_FAIL: "42414",
      DET_GHOST_ARR: "42450",
      SHUTIN_PLG_FALL: "42418",
      CASING_RISE: "42422",
      CRIT_FLOW_RATE: "42426",
      TUBING_CASING: "42430",
      OVER_RUN_SETPOINT: ["42371", "42372", "42373"],
      OVER_RUN_TIMER: ["42374", "42375", "42376"],
      UNDER_RUN_SETPOINT: ["42377", "42378", "42379"],
      UNDER_RUN_TIMER: ["42380", "42381", "42382"],
      MAX_UNDER_RUN: "42182",
      UNDER_RUN_DEC: "42183",
      MAX_OVER_RUN: "42184",
      OVER_RUN_INC: "42185",
      MAX_INC_DEC: "42186",
      MIN_FLOW_PID: "42871",
      MAX_FLOW_PID: "42875",
      MIN_CASING_PRS: "42883", //
      MAX_CASING_PRS: "42887", //
      COMP_SD: "42863",
      MAND_SHUTIN_SD: "42867",
      RESET_FAULT_CLEAR: "40094",
      START_PLG_LIFT: "40093",
      DISABLE_WELL: "42490",
      AUTO_SP: "43952", // == FLOW RATE AUTOMATIC SP
      CASING_ACTUAL: "40521", //NOT WRITABLE
      CASING_TIME_SAMPLE: "44030", //NOT WRITABLE
      SAMPLE_TIME: "44038",
      SAMPLE_DEADBAND: "44026",
      SETPOINT_INC_VAL: "44022",
      SETPOINT_DEC_VAL: "44018",
      MIN_FLOW_RATE: "41725",
      MAX_FLOW_RATE: "41724",
      // == FLOW RATE AUTOMATIC SP
      FLOW_RATE_DEADBAND: "43953",
      TUBING_CASING_SP: "42190",
      TUBING_CASING_DEBOUNCE: "42398",
      MAX_SHUTIN_RESET: "42446",
      PLG_FALL_TIMER: ["42368", "42369", "42370"],
      CASING_RISE_SP: "42189",
      CASING_RISE_DEBOUNCE: "42397",
      CASING_PID_AUTO_SP: "43936",
      CASING_PID_DEADBAND_SP: "43937",
      CRITICAL_FLOW_RATE_SP: "42187",
      CRITICAL_FLOW_RATE_DEADBAND: "42188",
      CRITICAL_FLOW_RATE_DEBOUNCE: "42396",
      MAX_AFTERFLOW_RESET: "42442",
      PLG_SD_SP_CASING_PRESURE: ["_41127", "_41128", "_41129", "_41130"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_TUBING_PRESURE: ["_41131", "_41132", "_41133", "_41134"], // LOLO - LO - HI - HIHI
      PLG_SD_SP_FLOWRATE_PRESURE: ["_41135", "_41136", "_41137", "_41138"], // LOLO - LO - HI - HIHI
      RESET_RUNTIMES: "44142",
      PROP_VALVE_CONTROL: "_44000",
      PROP_VALVE_POS: "_42406",
      PROP_MIN_OUTPUT: "_44005",
      PROP_MAX_OUTPUT: "_44006",
      PROP_MANUAL_SP: "_44042",
    },
  };
  return wellConfigs[wellId] || null;
};

export const wellsData = (apiData, config, status = "", overwatchValue) => {
  const isFlowRate = String(overwatchValue) === "1";
  const MIN_PID_KEY = isFlowRate ? config.MIN_FLOW_PID : config.MIN_CASING_PRS;

  const MAX_PID_KEY = isFlowRate ? config.MAX_FLOW_PID : config.MAX_CASING_PRS;
  return {
    1: {
      wellData: [
        {
          label: "Status",
          value: status,
        },
        {
          label: "State",
          value: PRC_WELL.getWellStateName(apiData[config.STATE]),
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
        },
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
        },
        {
          label: "Open Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.OPEN_TIME?.[0]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[1]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Afterflow Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AF_TIME?.[0]] || 0),
            parseInt(apiData[config.AF_TIME?.[1]] || 0),
            parseInt(apiData[config.AF_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Shutin Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.SHUTIN_TIME?.[0]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[1]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Mandatory Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MD_TIME?.[0]] || 0),
            parseInt(apiData[config.MD_TIME?.[1]] || 0),
            parseInt(apiData[config.MD_TIME?.[2]] || 0),
          ),
        },
      ],
      snapshot: [
        {
          label: "Current Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.CUR_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Previous Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.PRV_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Average Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Minimum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Maximum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
          ),
        },
      ],
      runTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
            ),
          },
        ],
        columnTwo: [
          {
            label: "24 HR Well Arrivals",
            value: `${apiData[config.WELL_ARRV]}`,
          },
          {
            label: "24 HR Missed Runs",
            value: `${apiData[config.WELL_MISR]}`,
          },
        ],
        columnThree: [
          {
            label: "Number of Over Runs",
            value: `${apiData[config.OVER_RUN]} `,
          },
          {
            label: "Number of Under Runs",
            value: `${apiData[config.UNDER_RUN]}`,
          },
          { label: "Number of INC/DEC", value: `${apiData[config.INC_DEC]}` },
        ],
        runTimesLeft: [
          {
            label: "Run 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN1?.[0]] || 0),
              parseInt(apiData[config.RUN1?.[1]] || 0),
              parseInt(apiData[config.RUN1?.[2]] || 0),
            ),
          },
          {
            label: "Run 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN2?.[0]] || 0),
              parseInt(apiData[config.RUN2?.[1]] || 0),
              parseInt(apiData[config.RUN2?.[2]] || 0),
            ),
          },
          {
            label: "Run 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN3?.[0]] || 0),
              parseInt(apiData[config.RUN3?.[1]] || 0),
              parseInt(apiData[config.RUN3?.[2]] || 0),
            ),
          },
          {
            label: "Run 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN4?.[0]] || 0),
              parseInt(apiData[config.RUN4?.[1]] || 0),
              parseInt(apiData[config.RUN4?.[2]] || 0),
            ),
          },
          {
            label: "Run 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN5?.[0]] || 0),
              parseInt(apiData[config.RUN5?.[1]] || 0),
              parseInt(apiData[config.RUN5?.[2]] || 0),
            ),
          },
          {
            label: "Run 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN6?.[0]] || 0),
              parseInt(apiData[config.RUN6?.[1]] || 0),
              parseInt(apiData[config.RUN6?.[2]] || 0),
            ),
          },
          {
            label: "Run 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN7?.[0]] || 0),
              parseInt(apiData[config.RUN7?.[1]] || 0),
              parseInt(apiData[config.RUN7?.[2]] || 0),
            ),
          },
          {
            label: "Run 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN8?.[0]] || 0),
              parseInt(apiData[config.RUN8?.[1]] || 0),
              parseInt(apiData[config.RUN8?.[2]] || 0),
            ),
          },
          {
            label: "Run 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN9?.[0]] || 0),
              parseInt(apiData[config.RUN9?.[1]] || 0),
              parseInt(apiData[config.RUN9?.[2]] || 0),
            ),
          },
          {
            label: "Run 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN10?.[0]] || 0),
              parseInt(apiData[config.RUN10?.[1]] || 0),
              parseInt(apiData[config.RUN10?.[2]] || 0),
            ),
          },
        ],
        runTimesRight: [
          {
            label: "Run 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN11?.[0]] || 0),
              parseInt(apiData[config.RUN11?.[1]] || 0),
              parseInt(apiData[config.RUN11?.[2]] || 0),
            ),
          },
          {
            label: "Run 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN12?.[0]] || 0),
              parseInt(apiData[config.RUN12?.[1]] || 0),
              parseInt(apiData[config.RUN12?.[2]] || 0),
            ),
          },
          {
            label: "Run 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN13?.[0]] || 0),
              parseInt(apiData[config.RUN13?.[1]] || 0),
              parseInt(apiData[config.RUN13?.[2]] || 0),
            ),
          },
          {
            label: "Run 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN14?.[0]] || 0),
              parseInt(apiData[config.RUN14?.[1]] || 0),
              parseInt(apiData[config.RUN14?.[2]] || 0),
            ),
          },
          {
            label: "Run 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN15?.[0]] || 0),
              parseInt(apiData[config.RUN15?.[1]] || 0),
              parseInt(apiData[config.RUN15?.[2]] || 0),
            ),
          },
          {
            label: "Run 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN16?.[0]] || 0),
              parseInt(apiData[config.RUN16?.[1]] || 0),
              parseInt(apiData[config.RUN16?.[2]] || 0),
            ),
          },
          {
            label: "Run 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN17?.[0]] || 0),
              parseInt(apiData[config.RUN17?.[1]] || 0),
              parseInt(apiData[config.RUN17?.[2]] || 0),
            ),
          },
          {
            label: "Run 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN18?.[0]] || 0),
              parseInt(apiData[config.RUN18?.[1]] || 0),
              parseInt(apiData[config.RUN18?.[2]] || 0),
            ),
          },
          {
            label: "Run 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN19?.[0]] || 0),
              parseInt(apiData[config.RUN19?.[1]] || 0),
              parseInt(apiData[config.RUN19?.[2]] || 0),
            ),
          },
          {
            label: "Run 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN20?.[0]] || 0),
              parseInt(apiData[config.RUN20?.[1]] || 0),
              parseInt(apiData[config.RUN20?.[2]] || 0),
            ),
          },
        ],
      },
      heldTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[2]] || 0),
            ),
          },
        ],
        heldTimesLeft: [
          {
            label: "Held Time 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD1?.[0]] || 0),
              parseInt(apiData[config.HELD1?.[1]] || 0),
              parseInt(apiData[config.HELD1?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD2?.[0]] || 0),
              parseInt(apiData[config.HELD2?.[1]] || 0),
              parseInt(apiData[config.HELD2?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD3?.[0]] || 0),
              parseInt(apiData[config.HELD3?.[1]] || 0),
              parseInt(apiData[config.HELD3?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD4?.[0]] || 0),
              parseInt(apiData[config.HELD4?.[1]] || 0),
              parseInt(apiData[config.HELD4?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD5?.[0]] || 0),
              parseInt(apiData[config.HELD5?.[1]] || 0),
              parseInt(apiData[config.HELD5?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD6?.[0]] || 0),
              parseInt(apiData[config.HELD6?.[1]] || 0),
              parseInt(apiData[config.HELD6?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD7?.[0]] || 0),
              parseInt(apiData[config.HELD7?.[1]] || 0),
              parseInt(apiData[config.HELD7?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD8?.[0]] || 0),
              parseInt(apiData[config.HELD8?.[1]] || 0),
              parseInt(apiData[config.HELD8?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD9?.[0]] || 0),
              parseInt(apiData[config.HELD9?.[1]] || 0),
              parseInt(apiData[config.HELD9?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD10?.[0]] || 0),
              parseInt(apiData[config.HELD10?.[1]] || 0),
              parseInt(apiData[config.HELD10?.[2]] || 0),
            ),
          },
        ],
        heldTimesRight: [
          {
            label: "Held Time 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD11?.[0]] || 0),
              parseInt(apiData[config.HELD11?.[1]] || 0),
              parseInt(apiData[config.HELD11?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD12?.[0]] || 0),
              parseInt(apiData[config.HELD12?.[1]] || 0),
              parseInt(apiData[config.HELD12?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD13?.[0]] || 0),
              parseInt(apiData[config.HELD13?.[1]] || 0),
              parseInt(apiData[config.HELD13?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD14?.[0]] || 0),
              parseInt(apiData[config.HELD14?.[1]] || 0),
              parseInt(apiData[config.HELD14?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD15?.[0]] || 0),
              parseInt(apiData[config.HELD15?.[1]] || 0),
              parseInt(apiData[config.HELD15?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD16?.[0]] || 0),
              parseInt(apiData[config.HELD16?.[1]] || 0),
              parseInt(apiData[config.HELD16?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD17?.[0]] || 0),
              parseInt(apiData[config.HELD17?.[1]] || 0),
              parseInt(apiData[config.HELD17?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD18?.[0]] || 0),
              parseInt(apiData[config.HELD18?.[1]] || 0),
              parseInt(apiData[config.HELD18?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD19?.[0]] || 0),
              parseInt(apiData[config.HELD19?.[1]] || 0),
              parseInt(apiData[config.HELD19?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD20?.[0]] || 0),
              parseInt(apiData[config.HELD20?.[1]] || 0),
              parseInt(apiData[config.HELD20?.[2]] || 0),
            ),
          },
        ],
      },
      plungerSDSPs: [
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[3]]) / 10 || 0,
          },
        },
      ],
      mainSettings: [
        {
          label: "Open Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Afterflow Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.AF_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.AF_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.AF_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Mandatory Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.MD_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.MD_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.MD_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Well Depth",
          fields: {
            value: apiData[config.WELL_DEPTH] || 0,
          },
          unit: "",
        },
        {
          label: "Max Missed Runs",
          fields: {
            value: apiData[config.MAX_MISSED_RUN] || 0,
          },
          unit: "",
        },
        {
          label: "Casing Inj Split Setpoint",
          fields: {
            value: apiData[config.CASING_INJ_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "Casing Inj Split Deadband",
          fields: {
            value: apiData[config.CASING_INJ_DEADBAND] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split SP [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split DB [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_DEADBAND] || 0,
          },
          unit: "PSI",
        },
      ],
      optimizationSettings: [
        { label: "Overwatch", value: apiData[config.OVERWATCH] },
        { label: "Detect Plunger Fall", value: apiData[config.DET_PLG_FAIL] },
        {
          label: "Detect Ghost Arrivals",
          value: apiData[config.DET_GHOST_ARR],
        },
        {
          label: "Shutin at Plunger Fall",
          value: apiData[config.SHUTIN_PLG_FALL],
        },
        { label: "Casing Rise", value: apiData[config.CASING_RISE] },
        { label: "Critical Flow Rate", value: apiData[config.CRIT_FLOW_RATE] },
        { label: "Tubing : Casing", value: apiData[config.TUBING_CASING] },
      ],
      proportionalValveControlsSettings: [
        { label: "Prop Valve Control", value: apiData[config.PROP_VALVE_CONTROL] ?? "" },
        { label: "Valve Position@4mA", value: apiData[config.PROP_VALVE_POS] ?? "" },
        {
          label: "Minimum Output %",
          value: (apiData[config.PROP_MIN_OUTPUT] / 100) || "",
        },
        {
          label: "Maximum Output %",
          value: (apiData[config.PROP_MAX_OUTPUT] / 100) || "",
        },
        { label: "Manual SP", value: (apiData[config.PROP_MANUAL_SP] / 100) || "" },
      ],
      rocConfig: [
        {
          label: "ROC Enable / Disable",
          value: apiData[config.ROC_ENABLE_DISABLE] ?? "",
        },
        { label: "Open State", value: apiData[config.ROC_OPEN_STATE] ?? "" },
        { label: "Afterflow State", value: apiData[config.ROC_AF_STATE] ?? "" },
        { label: "Shutin State", value: apiData[config.ROC_SHUTIN_STATE] ?? "" },
        {
          label: "Mandatory Shutin State",
          value: apiData[config.ROC_MANDATORY_SHUTIN_STATE] ?? "",
        },
      ],
      overwatchSettings: [
        {
          label: "Over Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Over Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[2]] || 0),
          },
        },
        {
          label: "Under Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Under Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[2]] || 0,
            ),
          },
        },
        {
          label: "Max Under Runs",
          value: apiData[config.MAX_UNDER_RUN] || 0,
        },
        { label: "Under Runs", value: apiData[config.UNDER_RUN] || 0 },
        {
          label: "Under Run Decrement",
          value: apiData[config.UNDER_RUN_DEC] || 0,
        },
        {
          label: "Max Over Runs",
          value: apiData[config.MAX_OVER_RUN] || 0,
        },
        {
          label: "Over Runs",
          value: apiData[config.OVER_RUN] || 0,
        },
        {
          label: "Over Run Increment",
          value: apiData[config.OVER_RUN_INC] || 0,
        },
        {
          label: "Inc / Dec",
          value: apiData[config.INC_DEC] || 0,
        },
        {
          label: "UnknownMin",
          value: apiData[MIN_PID_KEY] || 0,
        },
        {
          label: "UnknownMax",
          value: apiData[MAX_PID_KEY] || 0,
        },
      ],
      startStopSettings: [
        { label: "Compressor SD on Well SD", value: apiData[config.COMP_SD] },
        { label: "Mandatory Shutin SD", value: apiData[config.MAND_SHUTIN_SD] },
      ],
      timedIncrementalSettings: [
        {
          label: "Automatic SP",
          value: apiData[config.AUTO_SP],
          measurement: "MCF",
        },
        {
          label: "Casing PSI (Actual)",
          value: apiData[config.CASING_ACTUAL],
          measurement: "PSI",
        },
        {
          label: "Casing PSI (@Time of Sample)",
          value: apiData[config.CASING_TIME_SAMPLE],
          measurement: "PSI",
        },
        {
          label: "Sample Time SP",
          value: apiData[config.SAMPLE_TIME],
          measurement: "MIN",
        },
        {
          label: "Sample Deadband",
          value: apiData[config.SAMPLE_DEADBAND],
          measurement: "PSI",
        },
        {
          label: "Setpoint Increment Value",
          value: apiData[config.SETPOINT_INC_VAL],
          measurement: "PSI",
        },
        {
          label: "Setpoint Decrement Value",
          value: apiData[config.SETPOINT_DEC_VAL],
          measurement: "PSI",
        },
        {
          label: "Minimum Allowed Flow Rate",
          value: apiData[config.MIN_FLOW_RATE],
          measurement: "",
        },
        {
          label: "Maximum Allowed Flow Rate",
          value: apiData[config.MAX_FLOW_RATE],
          measurement: "",
        },
      ],
      analogSetpointsSettings: [
        {
          title: "Flow Rate Mode Setpoints",
          fields: [
            {
              label: "Flow Rate Automatic SP",
              value: apiData[config.AUTO_SP],
              unit: "MCF",
            },
            {
              label: "Flow Rate Deadband SP",
              value: apiData[config.FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
          ],
        },
        {
          title: "Casing PID Setpoints",
          fields: [
            {
              label: "Casing PID Automatic SP",
              value: apiData[config.CASING_PID_AUTO_SP],
              unit: "PSI",
            },
            {
              label: "Casing PID Deadband SP",
              value: apiData[config.CASING_PID_DEADBAND_SP],
              unit: "PSI",
            },
          ],
        },
        {
          title: "Tubing:Casing Ratio Setpoints",
          fields: [
            {
              label: "Tubing : Casing SP",
              value: apiData[config.TUBING_CASING_SP],
              unit: "%",
            },
            {
              label: "Tubing : Casing Debounce",
              value: apiData[config.TUBING_CASING_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Shutin Resets",
              value: apiData[config.MAX_SHUTIN_RESET],
              unit: "",
            },
            {
              label: "Plunger Fall Timer",
              fields: {
                hrs: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[0]] || 0,
                ),
                min: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[1]] || 0,
                ),
                sec: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[2]] || 0,
                ),
              },
              unit: "",
            },
          ],
          toBeEnabled: "Tubing : Casing",
          disabledText: "Tubing:Casing Optimization - Disabled",
        },
        {
          title: "Critical Flow Rate Setpoints",
          fields: [
            {
              label: "Critical Flow Rate SP",
              value: apiData[config.CRITICAL_FLOW_RATE_SP],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Deadband",
              value: apiData[config.CRITICAL_FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Debounce",
              value: apiData[config.CRITICAL_FLOW_RATE_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Afterflow Resets",
              value: apiData[config.MAX_AFTERFLOW_RESET],
              unit: "",
            },
          ],
          toBeEnabled: "Critical Flow Rate",
          disabledText: "Critical Flow Rate Optimization - Disabled",
        },
        {
          title: "Casing Rise Setpoints",
          fields: [
            {
              label: "Casing Rise SP",
              value: apiData[config.CASING_RISE_SP],
              unit: "PSI",
            },
            {
              label: "Casing Rise Debounce",
              value: apiData[config.CASING_RISE_DEBOUNCE],
              unit: "SEC",
            },
          ],
          toBeEnabled: "Casing Rise",
          disabledText: "Casing Rise Optimization - Disabled",
          fullWidth: true,
        },
      ],
    },
    2: {
      wellData: [
        { label: "Status", value: status || "" },
        {
          label: "State",
          value: PRC_WELL.getWellStateName(apiData[config.STATE]),
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
        },
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
        },
        {
          label: "Open Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.OPEN_TIME?.[0]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[1]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Afterflow Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AF_TIME?.[0]] || 0),
            parseInt(apiData[config.AF_TIME?.[1]] || 0),
            parseInt(apiData[config.AF_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Shutin Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.SHUTIN_TIME?.[0]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[1]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Mandatory Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MD_TIME?.[0]] || 0),
            parseInt(apiData[config.MD_TIME?.[1]] || 0),
            parseInt(apiData[config.MD_TIME?.[2]] || 0),
          ),
        },
      ],
      snapshot: [
        {
          label: "Current Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.CUR_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Previous Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.PRV_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Average Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Minimum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Maximum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
          ),
        },
      ],
      runTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
            ),
          },
        ],
        columnTwo: [
          {
            label: "24HR WELL ARRIVALS",
            value: `${apiData[config.WELL_ARRV]}`,
          },
          {
            label: "24HR MISSED RUNS",
            value: `${apiData[config.WELL_MISR]}`,
          },
        ],
        columnThree: [
          {
            label: "NUMBER OF OVER RUNS",
            value: `${apiData[config.OVER_RUN]} `,
          },
          {
            label: "NUMBER OF UNDER RUNS",
            value: `${apiData[config.UNDER_RUN]}`,
          },
          { label: "NUMBER OF INC/DEC", value: `${apiData[config.INC_DEC]}` },
        ],
        runTimesLeft: [
          {
            label: "Run 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN1?.[0]] || 0),
              parseInt(apiData[config.RUN1?.[1]] || 0),
              parseInt(apiData[config.RUN1?.[2]] || 0),
            ),
          },
          {
            label: "Run 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN2?.[0]] || 0),
              parseInt(apiData[config.RUN2?.[1]] || 0),
              parseInt(apiData[config.RUN2?.[2]] || 0),
            ),
          },
          {
            label: "Run 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN3?.[0]] || 0),
              parseInt(apiData[config.RUN3?.[1]] || 0),
              parseInt(apiData[config.RUN3?.[2]] || 0),
            ),
          },
          {
            label: "Run 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN4?.[0]] || 0),
              parseInt(apiData[config.RUN4?.[1]] || 0),
              parseInt(apiData[config.RUN4?.[2]] || 0),
            ),
          },
          {
            label: "Run 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN5?.[0]] || 0),
              parseInt(apiData[config.RUN5?.[1]] || 0),
              parseInt(apiData[config.RUN5?.[2]] || 0),
            ),
          },
          {
            label: "Run 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN6?.[0]] || 0),
              parseInt(apiData[config.RUN6?.[1]] || 0),
              parseInt(apiData[config.RUN6?.[2]] || 0),
            ),
          },
          {
            label: "Run 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN7?.[0]] || 0),
              parseInt(apiData[config.RUN7?.[1]] || 0),
              parseInt(apiData[config.RUN7?.[2]] || 0),
            ),
          },
          {
            label: "Run 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN8?.[0]] || 0),
              parseInt(apiData[config.RUN8?.[1]] || 0),
              parseInt(apiData[config.RUN8?.[2]] || 0),
            ),
          },
          {
            label: "Run 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN9?.[0]] || 0),
              parseInt(apiData[config.RUN9?.[1]] || 0),
              parseInt(apiData[config.RUN9?.[2]] || 0),
            ),
          },
          {
            label: "Run 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN10?.[0]] || 0),
              parseInt(apiData[config.RUN10?.[1]] || 0),
              parseInt(apiData[config.RUN10?.[2]] || 0),
            ),
          },
        ],
        runTimesRight: [
          {
            label: "Run 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN11?.[0]] || 0),
              parseInt(apiData[config.RUN11?.[1]] || 0),
              parseInt(apiData[config.RUN11?.[2]] || 0),
            ),
          },
          {
            label: "Run 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN12?.[0]] || 0),
              parseInt(apiData[config.RUN12?.[1]] || 0),
              parseInt(apiData[config.RUN12?.[2]] || 0),
            ),
          },
          {
            label: "Run 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN13?.[0]] || 0),
              parseInt(apiData[config.RUN13?.[1]] || 0),
              parseInt(apiData[config.RUN13?.[2]] || 0),
            ),
          },
          {
            label: "Run 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN14?.[0]] || 0),
              parseInt(apiData[config.RUN14?.[1]] || 0),
              parseInt(apiData[config.RUN14?.[2]] || 0),
            ),
          },
          {
            label: "Run 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN15?.[0]] || 0),
              parseInt(apiData[config.RUN15?.[1]] || 0),
              parseInt(apiData[config.RUN15?.[2]] || 0),
            ),
          },
          {
            label: "Run 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN16?.[0]] || 0),
              parseInt(apiData[config.RUN16?.[1]] || 0),
              parseInt(apiData[config.RUN16?.[2]] || 0),
            ),
          },
          {
            label: "Run 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN17?.[0]] || 0),
              parseInt(apiData[config.RUN17?.[1]] || 0),
              parseInt(apiData[config.RUN17?.[2]] || 0),
            ),
          },
          {
            label: "Run 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN18?.[0]] || 0),
              parseInt(apiData[config.RUN18?.[1]] || 0),
              parseInt(apiData[config.RUN18?.[2]] || 0),
            ),
          },
          {
            label: "Run 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN19?.[0]] || 0),
              parseInt(apiData[config.RUN19?.[1]] || 0),
              parseInt(apiData[config.RUN19?.[2]] || 0),
            ),
          },
          {
            label: "Run 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN20?.[0]] || 0),
              parseInt(apiData[config.RUN20?.[1]] || 0),
              parseInt(apiData[config.RUN20?.[2]] || 0),
            ),
          },
        ],
      },
      heldTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[2]] || 0),
            ),
          },
        ],
        heldTimesLeft: [
          {
            label: "Held Time 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD1?.[0]] || 0),
              parseInt(apiData[config.HELD1?.[1]] || 0),
              parseInt(apiData[config.HELD1?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD2?.[0]] || 0),
              parseInt(apiData[config.HELD2?.[1]] || 0),
              parseInt(apiData[config.HELD2?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD3?.[0]] || 0),
              parseInt(apiData[config.HELD3?.[1]] || 0),
              parseInt(apiData[config.HELD3?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD4?.[0]] || 0),
              parseInt(apiData[config.HELD4?.[1]] || 0),
              parseInt(apiData[config.HELD4?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD5?.[0]] || 0),
              parseInt(apiData[config.HELD5?.[1]] || 0),
              parseInt(apiData[config.HELD5?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD6?.[0]] || 0),
              parseInt(apiData[config.HELD6?.[1]] || 0),
              parseInt(apiData[config.HELD6?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD7?.[0]] || 0),
              parseInt(apiData[config.HELD7?.[1]] || 0),
              parseInt(apiData[config.HELD7?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD8?.[0]] || 0),
              parseInt(apiData[config.HELD8?.[1]] || 0),
              parseInt(apiData[config.HELD8?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD9?.[0]] || 0),
              parseInt(apiData[config.HELD9?.[1]] || 0),
              parseInt(apiData[config.HELD9?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD10?.[0]] || 0),
              parseInt(apiData[config.HELD10?.[1]] || 0),
              parseInt(apiData[config.HELD10?.[2]] || 0),
            ),
          },
        ],
        heldTimesRight: [
          {
            label: "Held Time 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD11?.[0]] || 0),
              parseInt(apiData[config.HELD11?.[1]] || 0),
              parseInt(apiData[config.HELD11?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD12?.[0]] || 0),
              parseInt(apiData[config.HELD12?.[1]] || 0),
              parseInt(apiData[config.HELD12?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD13?.[0]] || 0),
              parseInt(apiData[config.HELD13?.[1]] || 0),
              parseInt(apiData[config.HELD13?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD14?.[0]] || 0),
              parseInt(apiData[config.HELD14?.[1]] || 0),
              parseInt(apiData[config.HELD14?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD15?.[0]] || 0),
              parseInt(apiData[config.HELD15?.[1]] || 0),
              parseInt(apiData[config.HELD15?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD16?.[0]] || 0),
              parseInt(apiData[config.HELD16?.[1]] || 0),
              parseInt(apiData[config.HELD16?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD17?.[0]] || 0),
              parseInt(apiData[config.HELD17?.[1]] || 0),
              parseInt(apiData[config.HELD17?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD18?.[0]] || 0),
              parseInt(apiData[config.HELD18?.[1]] || 0),
              parseInt(apiData[config.HELD18?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD19?.[0]] || 0),
              parseInt(apiData[config.HELD19?.[1]] || 0),
              parseInt(apiData[config.HELD19?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD20?.[0]] || 0),
              parseInt(apiData[config.HELD20?.[1]] || 0),
              parseInt(apiData[config.HELD20?.[2]] || 0),
            ),
          },
        ],
      },
      plungerSDSPs: [
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[3]]) / 10 || 0,
          },
        },
      ],
      mainSettings: [
        {
          label: "Open Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Afterflow Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.AF_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.AF_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.AF_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Mandatory Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.MD_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.MD_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.MD_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Well Depth",
          fields: {
            value: apiData[config.WELL_DEPTH] || 0,
          },
          unit: "",
        },
        {
          label: "Max Missed Runs",
          fields: {
            value: apiData[config.MAX_MISSED_RUN] || 0,
          },
          unit: "",
        },
        {
          label: "Casing Inj Split Setpoint",
          fields: {
            value: apiData[config.CASING_INJ_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "Casing Inj Split Deadband",
          fields: {
            value: apiData[config.CASING_INJ_DEADBAND] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split SP [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split DB [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_DEADBAND] || 0,
          },
          unit: "PSI",
        },
      ],
      optimizationSettings: [
        { label: "Overwatch", value: apiData[config.OVERWATCH] },
        { label: "Detect Plunger Fall", value: apiData[config.DET_PLG_FAIL] },
        {
          label: "Detect Ghost Arrivals",
          value: apiData[config.DET_GHOST_ARR],
        },
        {
          label: "Shutin at Plunger Fall",
          value: apiData[config.SHUTIN_PLG_FALL],
        },
        { label: "Casing Rise", value: apiData[config.CASING_RISE] },
        { label: "Critical Flow Rate", value: apiData[config.CRIT_FLOW_RATE] },
        { label: "Tubing : Casing", value: apiData[config.TUBING_CASING] },
      ],
      proportionalValveControlsSettings: [
        { label: "Prop Valve Control", value: apiData[config.PROP_VALVE_CONTROL] ?? "" },
        { label: "Valve Position@4mA", value: apiData[config.PROP_VALVE_POS] ?? "" },
        {
          label: "Minimum Output %",
          value: (apiData[config.PROP_MIN_OUTPUT] / 100) || "",
        },
        {
          label: "Maximum Output %",
          value: (apiData[config.PROP_MAX_OUTPUT] / 100) || "",
        },
        { label: "Manual SP", value: (apiData[config.PROP_MANUAL_SP] / 100) || "" },
      ],
      overwatchSettings: [
        {
          label: "Over Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Over Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[2]] || 0),
          },
        },
        {
          label: "Under Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Under Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[2]] || 0,
            ),
          },
        },
        {
          label: "Max Under Runs",
          value: apiData[config.MAX_UNDER_RUN] || 0,
        },
        { label: "Under Runs", value: apiData[config.UNDER_RUN] || 0 },
        {
          label: "Under Run Decrement",
          value: apiData[config.UNDER_RUN_DEC] || 0,
        },
        {
          label: "Max Over Runs",
          value: apiData[config.MAX_OVER_RUN] || 0,
        },
        {
          label: "Over Runs",
          value: apiData[config.OVER_RUN] || 0,
        },
        {
          label: "Over Run Increment",
          value: apiData[config.OVER_RUN_INC] || 0,
        },
        {
          label: "Inc / Dec",
          value: apiData[config.INC_DEC] || 0,
        },
        {
          label: "UnknownMin",
          value: apiData[MIN_PID_KEY] || 0,
        },
        {
          label: "UnknownMax",
          value: apiData[MAX_PID_KEY] || 0,
        },
      ],
      startStopSettings: [
        { label: "Compressor SD on Well SD", value: apiData[config.COMP_SD] },
        { label: "Mandatory Shutin SD", value: apiData[config.MAND_SHUTIN_SD] },
      ],
      timedIncrementalSettings: [
        {
          label: "Automatic SP",
          value: apiData[config.AUTO_SP],
          measurement: "MCF",
        },
        {
          label: "Casing PSI (Actual)",
          value: apiData[config.CASING_ACTUAL],
          measurement: "PSI",
        },
        {
          label: "Casing PSI (@Time of Sample)",
          value: apiData[config.CASING_TIME_SAMPLE],
          measurement: "PSI",
        },
        {
          label: "Sample Time SP",
          value: apiData[config.SAMPLE_TIME],
          measurement: "MIN",
        },
        {
          label: "Sample Deadband",
          value: apiData[config.SAMPLE_DEADBAND],
          measurement: "PSI",
        },
        {
          label: "Setpoint Increment Value",
          value: apiData[config.SETPOINT_INC_VAL],
          measurement: "PSI",
        },
        {
          label: "Setpoint Decrement Value",
          value: apiData[config.SETPOINT_DEC_VAL],
          measurement: "PSI",
        },
        {
          label: "Minimum Allowed Flow Rate",
          value: apiData[config.MIN_FLOW_RATE],
          measurement: "",
        },
        {
          label: "Maximum Allowed Flow Rate",
          value: apiData[config.MAX_FLOW_RATE],
          measurement: "",
        },
      ],
      analogSetpointsSettings: [
        {
          title: "Flow Rate Mode Setpoints",
          fields: [
            {
              label: "Flow Rate Automatic SP",
              value: apiData[config.AUTO_SP],
              unit: "MCF",
            },
            {
              label: "Flow Rate Deadband SP",
              value: apiData[config.FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
          ],
        },
        {
          title: "Casing PID Setpoints",
          fields: [
            {
              label: "Casing PID Automatic SP",
              value: apiData[config.CASING_PID_AUTO_SP],
              unit: "PSI",
            },
            {
              label: "Casing PID Deadband SP",
              value: apiData[config.CASING_PID_DEADBAND_SP],
              unit: "PSI",
            },
          ],
        },
        {
          title: "Tubing:Casing Ratio Setpoints",
          fields: [
            {
              label: "Tubing : Casing SP",
              value: apiData[config.TUBING_CASING_SP],
              unit: "%",
            },
            {
              label: "Tubing : Casing Debounce",
              value: apiData[config.TUBING_CASING_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Shutin Resets",
              value: apiData[config.MAX_SHUTIN_RESET],
              unit: "",
            },
            {
              label: "Plunger Fall Timer",
              fields: {
                hrs: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[0]] || 0,
                ),
                min: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[1]] || 0,
                ),
                sec: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[2]] || 0,
                ),
              },
              unit: "",
            },
          ],
          toBeEnabled: "Tubing : Casing",
          disabledText: "Tubing:Casing Optimization - Disabled",
        },
        {
          title: "Critical Flow Rate Setpoints",
          fields: [
            {
              label: "Critical Flow Rate SP",
              value: apiData[config.CRITICAL_FLOW_RATE_SP],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Deadband",
              value: apiData[config.CRITICAL_FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Debounce",
              value: apiData[config.CRITICAL_FLOW_RATE_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Afterflow Resets",
              value: apiData[config.MAX_AFTERFLOW_RESET],
              unit: "",
            },
          ],
          toBeEnabled: "Critical Flow Rate",
          disabledText: "Critical Flow Rate Optimization - Disabled",
        },
        {
          title: "Casing Rise Setpoints",
          fields: [
            {
              label: "Casing Rise SP",
              value: apiData[config.CASING_RISE_SP],
              unit: "PSI",
            },
            {
              label: "Casing Rise Debounce",
              value: apiData[config.CASING_RISE_DEBOUNCE],
              unit: "SEC",
            },
          ],
          toBeEnabled: "Casing Rise",
          disabledText: "Casing Rise Optimization - Disabled",
          fullWidth: true,
        },
      ],
    },
    3: {
      wellData: [
        { label: "Status", value: status || "" },
        {
          label: "State",
          value: PRC_WELL.getWellStateName(apiData[config.STATE]),
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
        },
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
        },
        {
          label: "Open Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.OPEN_TIME?.[0]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[1]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Afterflow Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AF_TIME?.[0]] || 0),
            parseInt(apiData[config.AF_TIME?.[1]] || 0),
            parseInt(apiData[config.AF_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Shutin Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.SHUTIN_TIME?.[0]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[1]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Mandatory Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MD_TIME?.[0]] || 0),
            parseInt(apiData[config.MD_TIME?.[1]] || 0),
            parseInt(apiData[config.MD_TIME?.[2]] || 0),
          ),
        },
      ],
      snapshot: [
        {
          label: "Current Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.CUR_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Previous Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.PRV_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Average Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Minimum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Maximum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
          ),
        },
      ],
      runTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
            ),
          },
        ],
        columnTwo: [
          {
            label: "24HR WELL ARRIVALS",
            value: `${apiData[config.WELL_ARRV]}`,
          },
          {
            label: "24HR MISSED RUNS",
            value: `${apiData[config.WELL_MISR]}`,
          },
        ],
        columnThree: [
          {
            label: "NUMBER OF OVER RUNS",
            value: `${apiData[config.OVER_RUN]} `,
          },
          {
            label: "NUMBER OF UNDER RUNS",
            value: `${apiData[config.UNDER_RUN]}`,
          },
          { label: "NUMBER OF INC/DEC", value: `${apiData[config.INC_DEC]}` },
        ],
        runTimesLeft: [
          {
            label: "Run 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN1?.[0]] || 0),
              parseInt(apiData[config.RUN1?.[1]] || 0),
              parseInt(apiData[config.RUN1?.[2]] || 0),
            ),
          },
          {
            label: "Run 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN2?.[0]] || 0),
              parseInt(apiData[config.RUN2?.[1]] || 0),
              parseInt(apiData[config.RUN2?.[2]] || 0),
            ),
          },
          {
            label: "Run 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN3?.[0]] || 0),
              parseInt(apiData[config.RUN3?.[1]] || 0),
              parseInt(apiData[config.RUN3?.[2]] || 0),
            ),
          },
          {
            label: "Run 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN4?.[0]] || 0),
              parseInt(apiData[config.RUN4?.[1]] || 0),
              parseInt(apiData[config.RUN4?.[2]] || 0),
            ),
          },
          {
            label: "Run 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN5?.[0]] || 0),
              parseInt(apiData[config.RUN5?.[1]] || 0),
              parseInt(apiData[config.RUN5?.[2]] || 0),
            ),
          },
          {
            label: "Run 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN6?.[0]] || 0),
              parseInt(apiData[config.RUN6?.[1]] || 0),
              parseInt(apiData[config.RUN6?.[2]] || 0),
            ),
          },
          {
            label: "Run 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN7?.[0]] || 0),
              parseInt(apiData[config.RUN7?.[1]] || 0),
              parseInt(apiData[config.RUN7?.[2]] || 0),
            ),
          },
          {
            label: "Run 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN8?.[0]] || 0),
              parseInt(apiData[config.RUN8?.[1]] || 0),
              parseInt(apiData[config.RUN8?.[2]] || 0),
            ),
          },
          {
            label: "Run 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN9?.[0]] || 0),
              parseInt(apiData[config.RUN9?.[1]] || 0),
              parseInt(apiData[config.RUN9?.[2]] || 0),
            ),
          },
          {
            label: "Run 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN10?.[0]] || 0),
              parseInt(apiData[config.RUN10?.[1]] || 0),
              parseInt(apiData[config.RUN10?.[2]] || 0),
            ),
          },
        ],
        runTimesRight: [
          {
            label: "Run 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN11?.[0]] || 0),
              parseInt(apiData[config.RUN11?.[1]] || 0),
              parseInt(apiData[config.RUN11?.[2]] || 0),
            ),
          },
          {
            label: "Run 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN12?.[0]] || 0),
              parseInt(apiData[config.RUN12?.[1]] || 0),
              parseInt(apiData[config.RUN12?.[2]] || 0),
            ),
          },
          {
            label: "Run 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN13?.[0]] || 0),
              parseInt(apiData[config.RUN13?.[1]] || 0),
              parseInt(apiData[config.RUN13?.[2]] || 0),
            ),
          },
          {
            label: "Run 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN14?.[0]] || 0),
              parseInt(apiData[config.RUN14?.[1]] || 0),
              parseInt(apiData[config.RUN14?.[2]] || 0),
            ),
          },
          {
            label: "Run 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN15?.[0]] || 0),
              parseInt(apiData[config.RUN15?.[1]] || 0),
              parseInt(apiData[config.RUN15?.[2]] || 0),
            ),
          },
          {
            label: "Run 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN16?.[0]] || 0),
              parseInt(apiData[config.RUN16?.[1]] || 0),
              parseInt(apiData[config.RUN16?.[2]] || 0),
            ),
          },
          {
            label: "Run 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN17?.[0]] || 0),
              parseInt(apiData[config.RUN17?.[1]] || 0),
              parseInt(apiData[config.RUN17?.[2]] || 0),
            ),
          },
          {
            label: "Run 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN18?.[0]] || 0),
              parseInt(apiData[config.RUN18?.[1]] || 0),
              parseInt(apiData[config.RUN18?.[2]] || 0),
            ),
          },
          {
            label: "Run 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN19?.[0]] || 0),
              parseInt(apiData[config.RUN19?.[1]] || 0),
              parseInt(apiData[config.RUN19?.[2]] || 0),
            ),
          },
          {
            label: "Run 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN20?.[0]] || 0),
              parseInt(apiData[config.RUN20?.[1]] || 0),
              parseInt(apiData[config.RUN20?.[2]] || 0),
            ),
          },
        ],
      },
      heldTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[2]] || 0),
            ),
          },
        ],
        heldTimesLeft: [
          {
            label: "Held Time 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD1?.[0]] || 0),
              parseInt(apiData[config.HELD1?.[1]] || 0),
              parseInt(apiData[config.HELD1?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD2?.[0]] || 0),
              parseInt(apiData[config.HELD2?.[1]] || 0),
              parseInt(apiData[config.HELD2?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD3?.[0]] || 0),
              parseInt(apiData[config.HELD3?.[1]] || 0),
              parseInt(apiData[config.HELD3?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD4?.[0]] || 0),
              parseInt(apiData[config.HELD4?.[1]] || 0),
              parseInt(apiData[config.HELD4?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD5?.[0]] || 0),
              parseInt(apiData[config.HELD5?.[1]] || 0),
              parseInt(apiData[config.HELD5?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD6?.[0]] || 0),
              parseInt(apiData[config.HELD6?.[1]] || 0),
              parseInt(apiData[config.HELD6?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD7?.[0]] || 0),
              parseInt(apiData[config.HELD7?.[1]] || 0),
              parseInt(apiData[config.HELD7?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD8?.[0]] || 0),
              parseInt(apiData[config.HELD8?.[1]] || 0),
              parseInt(apiData[config.HELD8?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD9?.[0]] || 0),
              parseInt(apiData[config.HELD9?.[1]] || 0),
              parseInt(apiData[config.HELD9?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD10?.[0]] || 0),
              parseInt(apiData[config.HELD10?.[1]] || 0),
              parseInt(apiData[config.HELD10?.[2]] || 0),
            ),
          },
        ],
        heldTimesRight: [
          {
            label: "Held Time 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD11?.[0]] || 0),
              parseInt(apiData[config.HELD11?.[1]] || 0),
              parseInt(apiData[config.HELD11?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD12?.[0]] || 0),
              parseInt(apiData[config.HELD12?.[1]] || 0),
              parseInt(apiData[config.HELD12?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD13?.[0]] || 0),
              parseInt(apiData[config.HELD13?.[1]] || 0),
              parseInt(apiData[config.HELD13?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD14?.[0]] || 0),
              parseInt(apiData[config.HELD14?.[1]] || 0),
              parseInt(apiData[config.HELD14?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD15?.[0]] || 0),
              parseInt(apiData[config.HELD15?.[1]] || 0),
              parseInt(apiData[config.HELD15?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD16?.[0]] || 0),
              parseInt(apiData[config.HELD16?.[1]] || 0),
              parseInt(apiData[config.HELD16?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD17?.[0]] || 0),
              parseInt(apiData[config.HELD17?.[1]] || 0),
              parseInt(apiData[config.HELD17?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD18?.[0]] || 0),
              parseInt(apiData[config.HELD18?.[1]] || 0),
              parseInt(apiData[config.HELD18?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD19?.[0]] || 0),
              parseInt(apiData[config.HELD19?.[1]] || 0),
              parseInt(apiData[config.HELD19?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD20?.[0]] || 0),
              parseInt(apiData[config.HELD20?.[1]] || 0),
              parseInt(apiData[config.HELD20?.[2]] || 0),
            ),
          },
        ],
      },
      plungerSDSPs: [
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[3]]) / 10 || 0,
          },
        },
      ],
      mainSettings: [
        {
          label: "Open Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Afterflow Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.AF_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.AF_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.AF_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Mandatory Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.MD_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.MD_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.MD_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Well Depth",
          fields: {
            value: apiData[config.WELL_DEPTH] || 0,
          },
          unit: "",
        },
        {
          label: "Max Missed Runs",
          fields: {
            value: apiData[config.MAX_MISSED_RUN] || 0,
          },
          unit: "",
        },
        {
          label: "Casing Inj Split Setpoint",
          fields: {
            value: apiData[config.CASING_INJ_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "Casing Inj Split Deadband",
          fields: {
            value: apiData[config.CASING_INJ_DEADBAND] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split SP [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split DB [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_DEADBAND] || 0,
          },
          unit: "PSI",
        },
      ],
      optimizationSettings: [
        { label: "Overwatch", value: apiData[config.OVERWATCH] },
        { label: "Detect Plunger Fall", value: apiData[config.DET_PLG_FAIL] },
        {
          label: "Detect Ghost Arrivals",
          value: apiData[config.DET_GHOST_ARR],
        },
        {
          label: "Shutin at Plunger Fall",
          value: apiData[config.SHUTIN_PLG_FALL],
        },
        { label: "Casing Rise", value: apiData[config.CASING_RISE] },
        { label: "Critical Flow Rate", value: apiData[config.CRIT_FLOW_RATE] },
        { label: "Tubing : Casing", value: apiData[config.TUBING_CASING] },
      ],
      proportionalValveControlsSettings: [
        { label: "Prop Valve Control", value: apiData[config.PROP_VALVE_CONTROL] ?? "" },
        { label: "Valve Position@4mA", value: apiData[config.PROP_VALVE_POS] ?? "" },
        {
          label: "Minimum Output %",
          value: (apiData[config.PROP_MIN_OUTPUT] / 100) || "",
        },
        {
          label: "Maximum Output %",
          value: (apiData[config.PROP_MAX_OUTPUT] / 100) || "",
        },
        { label: "Manual SP", value: (apiData[config.PROP_MANUAL_SP] / 100) || "" },
      ],
      overwatchSettings: [
        {
          label: "Over Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Over Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[2]] || 0),
          },
        },
        {
          label: "Under Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Under Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[2]] || 0,
            ),
          },
        },
        {
          label: "Max Under Runs",
          value: apiData[config.MAX_UNDER_RUN] || 0,
        },
        { label: "Under Runs", value: apiData[config.UNDER_RUN] || 0 },
        {
          label: "Under Run Decrement",
          value: apiData[config.UNDER_RUN_DEC] || 0,
        },
        {
          label: "Max Over Runs",
          value: apiData[config.MAX_OVER_RUN] || 0,
        },
        {
          label: "Over Runs",
          value: apiData[config.OVER_RUN] || 0,
        },
        {
          label: "Over Run Increment",
          value: apiData[config.OVER_RUN_INC] || 0,
        },
        {
          label: "Inc / Dec",
          value: apiData[config.INC_DEC] || 0,
        },
        {
          label: "UnknownMin",
          value: apiData[MIN_PID_KEY] || 0,
        },
        {
          label: "UnknownMax",
          value: apiData[MAX_PID_KEY] || 0,
        },
      ],
      startStopSettings: [
        { label: "Compressor SD on Well SD", value: apiData[config.COMP_SD] },
        { label: "Mandatory Shutin SD", value: apiData[config.MAND_SHUTIN_SD] },
      ],
      timedIncrementalSettings: [
        {
          label: "Automatic SP",
          value: apiData[config.AUTO_SP],
          measurement: "MCF",
        },
        {
          label: "Casing PSI (Actual)",
          value: apiData[config.CASING_ACTUAL],
          measurement: "PSI",
        },
        {
          label: "Casing PSI (@Time of Sample)",
          value: apiData[config.CASING_TIME_SAMPLE],
          measurement: "PSI",
        },
        {
          label: "Sample Time SP",
          value: apiData[config.SAMPLE_TIME],
          measurement: "MIN",
        },
        {
          label: "Sample Deadband",
          value: apiData[config.SAMPLE_DEADBAND],
          measurement: "PSI",
        },
        {
          label: "Setpoint Increment Value",
          value: apiData[config.SETPOINT_INC_VAL],
          measurement: "PSI",
        },
        {
          label: "Setpoint Decrement Value",
          value: apiData[config.SETPOINT_DEC_VAL],
          measurement: "PSI",
        },
        {
          label: "Minimum Allowed Flow Rate",
          value: apiData[config.MIN_FLOW_RATE],
          measurement: "",
        },
        {
          label: "Maximum Allowed Flow Rate",
          value: apiData[config.MAX_FLOW_RATE],
          measurement: "",
        },
      ],
      analogSetpointsSettings: [
        {
          title: "Flow Rate Mode Setpoints",
          fields: [
            {
              label: "Flow Rate Automatic SP",
              value: apiData[config.AUTO_SP],
              unit: "MCF",
            },
            {
              label: "Flow Rate Deadband SP",
              value: apiData[config.FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
          ],
        },
        {
          title: "Casing PID Setpoints",
          fields: [
            {
              label: "Casing PID Automatic SP",
              value: apiData[config.CASING_PID_AUTO_SP],
              unit: "PSI",
            },
            {
              label: "Casing PID Deadband SP",
              value: apiData[config.CASING_PID_DEADBAND_SP],
              unit: "PSI",
            },
          ],
        },
        {
          title: "Tubing:Casing Ratio Setpoints",
          fields: [
            {
              label: "Tubing : Casing SP",
              value: apiData[config.TUBING_CASING_SP],
              unit: "%",
            },
            {
              label: "Tubing : Casing Debounce",
              value: apiData[config.TUBING_CASING_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Shutin Resets",
              value: apiData[config.MAX_SHUTIN_RESET],
              unit: "",
            },
            {
              label: "Plunger Fall Timer",
              fields: {
                hrs: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[0]] || 0,
                ),
                min: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[1]] || 0,
                ),
                sec: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[2]] || 0,
                ),
              },
              unit: "",
            },
          ],
          toBeEnabled: "Tubing : Casing",
          disabledText: "Tubing:Casing Optimization - Disabled",
        },
        {
          title: "Critical Flow Rate Setpoints",
          fields: [
            {
              label: "Critical Flow Rate SP",
              value: apiData[config.CRITICAL_FLOW_RATE_SP],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Deadband",
              value: apiData[config.CRITICAL_FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Debounce",
              value: apiData[config.CRITICAL_FLOW_RATE_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Afterflow Resets",
              value: apiData[config.MAX_AFTERFLOW_RESET],
              unit: "",
            },
          ],
          toBeEnabled: "Critical Flow Rate",
          disabledText: "Critical Flow Rate Optimization - Disabled",
        },
        {
          title: "Casing Rise Setpoints",
          fields: [
            {
              label: "Casing Rise SP",
              value: apiData[config.CASING_RISE_SP],
              unit: "PSI",
            },
            {
              label: "Casing Rise Debounce",
              value: apiData[config.CASING_RISE_DEBOUNCE],
              unit: "SEC",
            },
          ],
          toBeEnabled: "Casing Rise",
          disabledText: "Casing Rise Optimization - Disabled",
          fullWidth: true,
        },
      ],
    },
    4: {
      wellData: [
        { label: "Status", value: status || "" },
        {
          label: "State",
          value: PRC_WELL.getWellStateName(apiData[config.STATE]),
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
        },
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
        },
        {
          label: "Open Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.OPEN_TIME?.[0]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[1]] || 0),
            parseInt(apiData[config.OPEN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Afterflow Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AF_TIME?.[0]] || 0),
            parseInt(apiData[config.AF_TIME?.[1]] || 0),
            parseInt(apiData[config.AF_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Shutin Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.SHUTIN_TIME?.[0]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[1]] || 0),
            parseInt(apiData[config.SHUTIN_TIME?.[2]] || 0),
          ),
        },
        {
          label: "Mandatory Time Setting",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MD_TIME?.[0]] || 0),
            parseInt(apiData[config.MD_TIME?.[1]] || 0),
            parseInt(apiData[config.MD_TIME?.[2]] || 0),
          ),
        },
      ],
      snapshot: [
        {
          label: "Current Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.CUR_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.CUR_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Previous Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.PRV_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.PRV_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Average Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Minimum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
          ),
        },
        {
          label: "Maximum Run Time",
          value: PRC_WELL.formatSecondsToTime(
            parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
            parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
          ),
        },
      ],
      runTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.AVG_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MIN_RUNTIME?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_RUNTIME?.[0]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[1]] || 0),
              parseInt(apiData[config.MAX_RUNTIME?.[2]] || 0),
            ),
          },
        ],
        columnTwo: [
          {
            label: "24HR WELL ARRIVALS",
            value: `${apiData[config.WELL_ARRV]}`,
          },
          {
            label: "24HR MISSED RUNS",
            value: `${apiData[config.WELL_MISR]}`,
          },
        ],
        columnThree: [
          {
            label: "NUMBER OF OVER RUNS",
            value: `${apiData[config.OVER_RUN]} `,
          },
          {
            label: "NUMBER OF UNDER RUNS",
            value: `${apiData[config.UNDER_RUN]}`,
          },
          { label: "NUMBER OF INC/DEC", value: `${apiData[config.INC_DEC]}` },
        ],
        runTimesLeft: [
          {
            label: "Run 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN1?.[0]] || 0),
              parseInt(apiData[config.RUN1?.[1]] || 0),
              parseInt(apiData[config.RUN1?.[2]] || 0),
            ),
          },
          {
            label: "Run 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN2?.[0]] || 0),
              parseInt(apiData[config.RUN2?.[1]] || 0),
              parseInt(apiData[config.RUN2?.[2]] || 0),
            ),
          },
          {
            label: "Run 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN3?.[0]] || 0),
              parseInt(apiData[config.RUN3?.[1]] || 0),
              parseInt(apiData[config.RUN3?.[2]] || 0),
            ),
          },
          {
            label: "Run 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN4?.[0]] || 0),
              parseInt(apiData[config.RUN4?.[1]] || 0),
              parseInt(apiData[config.RUN4?.[2]] || 0),
            ),
          },
          {
            label: "Run 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN5?.[0]] || 0),
              parseInt(apiData[config.RUN5?.[1]] || 0),
              parseInt(apiData[config.RUN5?.[2]] || 0),
            ),
          },
          {
            label: "Run 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN6?.[0]] || 0),
              parseInt(apiData[config.RUN6?.[1]] || 0),
              parseInt(apiData[config.RUN6?.[2]] || 0),
            ),
          },
          {
            label: "Run 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN7?.[0]] || 0),
              parseInt(apiData[config.RUN7?.[1]] || 0),
              parseInt(apiData[config.RUN7?.[2]] || 0),
            ),
          },
          {
            label: "Run 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN8?.[0]] || 0),
              parseInt(apiData[config.RUN8?.[1]] || 0),
              parseInt(apiData[config.RUN8?.[2]] || 0),
            ),
          },
          {
            label: "Run 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN9?.[0]] || 0),
              parseInt(apiData[config.RUN9?.[1]] || 0),
              parseInt(apiData[config.RUN9?.[2]] || 0),
            ),
          },
          {
            label: "Run 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN10?.[0]] || 0),
              parseInt(apiData[config.RUN10?.[1]] || 0),
              parseInt(apiData[config.RUN10?.[2]] || 0),
            ),
          },
        ],
        runTimesRight: [
          {
            label: "Run 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN11?.[0]] || 0),
              parseInt(apiData[config.RUN11?.[1]] || 0),
              parseInt(apiData[config.RUN11?.[2]] || 0),
            ),
          },
          {
            label: "Run 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN12?.[0]] || 0),
              parseInt(apiData[config.RUN12?.[1]] || 0),
              parseInt(apiData[config.RUN12?.[2]] || 0),
            ),
          },
          {
            label: "Run 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN13?.[0]] || 0),
              parseInt(apiData[config.RUN13?.[1]] || 0),
              parseInt(apiData[config.RUN13?.[2]] || 0),
            ),
          },
          {
            label: "Run 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN14?.[0]] || 0),
              parseInt(apiData[config.RUN14?.[1]] || 0),
              parseInt(apiData[config.RUN14?.[2]] || 0),
            ),
          },
          {
            label: "Run 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN15?.[0]] || 0),
              parseInt(apiData[config.RUN15?.[1]] || 0),
              parseInt(apiData[config.RUN15?.[2]] || 0),
            ),
          },
          {
            label: "Run 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN16?.[0]] || 0),
              parseInt(apiData[config.RUN16?.[1]] || 0),
              parseInt(apiData[config.RUN16?.[2]] || 0),
            ),
          },
          {
            label: "Run 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN17?.[0]] || 0),
              parseInt(apiData[config.RUN17?.[1]] || 0),
              parseInt(apiData[config.RUN17?.[2]] || 0),
            ),
          },
          {
            label: "Run 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN18?.[0]] || 0),
              parseInt(apiData[config.RUN18?.[1]] || 0),
              parseInt(apiData[config.RUN18?.[2]] || 0),
            ),
          },
          {
            label: "Run 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN19?.[0]] || 0),
              parseInt(apiData[config.RUN19?.[1]] || 0),
              parseInt(apiData[config.RUN19?.[2]] || 0),
            ),
          },
          {
            label: "Run 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.RUN20?.[0]] || 0),
              parseInt(apiData[config.RUN20?.[1]] || 0),
              parseInt(apiData[config.RUN20?.[2]] || 0),
            ),
          },
        ],
      },
      heldTimes: {
        columnOne: [
          {
            label: "Avg",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.AVG_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.AVG_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Min",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MIN_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MIN_HELDTIMES?.[2]] || 0),
            ),
          },
          {
            label: "Max",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.MAX_HELDTIMES?.[0]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[1]] || 0),
              parseInt(apiData[config.MAX_HELDTIMES?.[2]] || 0),
            ),
          },
        ],
        heldTimesLeft: [
          {
            label: "Held Time 1",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD1?.[0]] || 0),
              parseInt(apiData[config.HELD1?.[1]] || 0),
              parseInt(apiData[config.HELD1?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 2",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD2?.[0]] || 0),
              parseInt(apiData[config.HELD2?.[1]] || 0),
              parseInt(apiData[config.HELD2?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 3",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD3?.[0]] || 0),
              parseInt(apiData[config.HELD3?.[1]] || 0),
              parseInt(apiData[config.HELD3?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 4",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD4?.[0]] || 0),
              parseInt(apiData[config.HELD4?.[1]] || 0),
              parseInt(apiData[config.HELD4?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 5",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD5?.[0]] || 0),
              parseInt(apiData[config.HELD5?.[1]] || 0),
              parseInt(apiData[config.HELD5?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 6",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD6?.[0]] || 0),
              parseInt(apiData[config.HELD6?.[1]] || 0),
              parseInt(apiData[config.HELD6?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 7",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD7?.[0]] || 0),
              parseInt(apiData[config.HELD7?.[1]] || 0),
              parseInt(apiData[config.HELD7?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 8",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD8?.[0]] || 0),
              parseInt(apiData[config.HELD8?.[1]] || 0),
              parseInt(apiData[config.HELD8?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 9",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD9?.[0]] || 0),
              parseInt(apiData[config.HELD9?.[1]] || 0),
              parseInt(apiData[config.HELD9?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 10",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD10?.[0]] || 0),
              parseInt(apiData[config.HELD10?.[1]] || 0),
              parseInt(apiData[config.HELD10?.[2]] || 0),
            ),
          },
        ],
        heldTimesRight: [
          {
            label: "Held Time 11",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD11?.[0]] || 0),
              parseInt(apiData[config.HELD11?.[1]] || 0),
              parseInt(apiData[config.HELD11?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 12",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD12?.[0]] || 0),
              parseInt(apiData[config.HELD12?.[1]] || 0),
              parseInt(apiData[config.HELD12?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 13",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD13?.[0]] || 0),
              parseInt(apiData[config.HELD13?.[1]] || 0),
              parseInt(apiData[config.HELD13?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 14",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD14?.[0]] || 0),
              parseInt(apiData[config.HELD14?.[1]] || 0),
              parseInt(apiData[config.HELD14?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 15",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD15?.[0]] || 0),
              parseInt(apiData[config.HELD15?.[1]] || 0),
              parseInt(apiData[config.HELD15?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 16",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD16?.[0]] || 0),
              parseInt(apiData[config.HELD16?.[1]] || 0),
              parseInt(apiData[config.HELD16?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 17",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD17?.[0]] || 0),
              parseInt(apiData[config.HELD17?.[1]] || 0),
              parseInt(apiData[config.HELD17?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 18",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD18?.[0]] || 0),
              parseInt(apiData[config.HELD18?.[1]] || 0),
              parseInt(apiData[config.HELD18?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 19",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD19?.[0]] || 0),
              parseInt(apiData[config.HELD19?.[1]] || 0),
              parseInt(apiData[config.HELD19?.[2]] || 0),
            ),
          },
          {
            label: "Held Time 20",
            value: PRC_WELL.formatSecondsToTime(
              parseInt(apiData[config.HELD20?.[0]] || 0),
              parseInt(apiData[config.HELD20?.[1]] || 0),
              parseInt(apiData[config.HELD20?.[2]] || 0),
            ),
          },
        ],
      },
      plungerSDSPs: [
        {
          label: "Casing Pressure",
          value: apiData[config.CASING]
            ? PRC_WELL.loadValue(apiData[config.CASING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_CASING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Tubing Pressure",
          value: apiData[config.TUBING]
            ? PRC_WELL.loadValue(apiData[config.TUBING], "PSI")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_TUBING_PRESURE?.[3]]) / 10 || 0,
          },
        },
        {
          label: "Flow Rate",
          value: apiData[config.FLOW_RATE]
            ? PRC_WELL.loadValue(apiData[config.FLOW_RATE], "MCF")
            : "-",
          regs: {
            LOLO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[0]]) / 10 || 0,
            LO: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[1]]) / 10 || 0,
            HI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[2]]) / 10 || 0,
            HIHI: uint16ToInt16(apiData[config.PLG_SD_SP_FLOWRATE_PRESURE?.[3]]) / 10 || 0,
          },
        },
      ],
      mainSettings: [
        {
          label: "Open Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OPEN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Afterflow Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.AF_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.AF_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.AF_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.SHUTIN_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Mandatory Shutin Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.MD_TIME?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.MD_TIME?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.MD_TIME?.[2]] || 0),
          },
          unit: "",
        },
        {
          label: "Well Depth",
          fields: {
            value: apiData[config.WELL_DEPTH] || 0,
          },
          unit: "",
        },
        {
          label: "Max Missed Runs",
          fields: {
            value: apiData[config.MAX_MISSED_RUN] || 0,
          },
          unit: "",
        },
        {
          label: "Casing Inj Split Setpoint",
          fields: {
            value: apiData[config.CASING_INJ_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "Casing Inj Split Deadband",
          fields: {
            value: apiData[config.CASING_INJ_DEADBAND] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split SP [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_SETPOINT] || 0,
          },
          unit: "PSI",
        },
        {
          label: "HI Casing Inj Split DB [Inj Split Override]",
          fields: {
            value: apiData[config.CASING_INJ_HI_DEADBAND] || 0,
          },
          unit: "PSI",
        },
      ],
      optimizationSettings: [
        { label: "Overwatch", value: apiData[config.OVERWATCH] },
        { label: "Detect Plunger Fall", value: apiData[config.DET_PLG_FAIL] },
        {
          label: "Detect Ghost Arrivals",
          value: apiData[config.DET_GHOST_ARR],
        },
        {
          label: "Shutin at Plunger Fall",
          value: apiData[config.SHUTIN_PLG_FALL],
        },
        { label: "Casing Rise", value: apiData[config.CASING_RISE] },
        { label: "Critical Flow Rate", value: apiData[config.CRIT_FLOW_RATE] },
        { label: "Tubing : Casing", value: apiData[config.TUBING_CASING] },
      ],
      proportionalValveControlsSettings: [
        { label: "Prop Valve Control", value: apiData[config.PROP_VALVE_CONTROL] ?? "" },
        { label: "Valve Position@4mA", value: apiData[config.PROP_VALVE_POS] ?? "" },
        {
          label: "Minimum Output %",
          value: (apiData[config.PROP_MIN_OUTPUT] / 100) || "",
        },
        {
          label: "Maximum Output %",
          value: (apiData[config.PROP_MAX_OUTPUT] / 100) || "",
        },
        { label: "Manual SP", value: (apiData[config.PROP_MANUAL_SP] / 100) || "" },
      ],
      overwatchSettings: [
        {
          label: "Over Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.OVER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Over Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[0]] || 0),
            min: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[1]] || 0),
            sec: PRC_WELL.formatHours(apiData[config.OVER_RUN_TIMER?.[2]] || 0),
          },
        },
        {
          label: "Under Run Setpoint",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_SETPOINT?.[2]] || 0,
            ),
          },
        },
        {
          label: "Under Run Timer",
          fields: {
            hrs: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[0]] || 0,
            ),
            min: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[1]] || 0,
            ),
            sec: PRC_WELL.formatHours(
              apiData[config.UNDER_RUN_TIMER?.[2]] || 0,
            ),
          },
        },
        {
          label: "Max Under Runs",
          value: apiData[config.MAX_UNDER_RUN] || 0,
        },
        { label: "Under Runs", value: apiData[config.UNDER_RUN] || 0 },
        {
          label: "Under Run Decrement",
          value: apiData[config.UNDER_RUN_DEC] || 0,
        },
        {
          label: "Max Over Runs",
          value: apiData[config.MAX_OVER_RUN] || 0,
        },
        {
          label: "Over Runs",
          value: apiData[config.OVER_RUN] || 0,
        },
        {
          label: "Over Run Increment",
          value: apiData[config.OVER_RUN_INC] || 0,
        },
        {
          label: "Inc / Dec",
          value: apiData[config.INC_DEC] || 0,
        },
        {
          label: "UnknownMin",
          value: apiData[MIN_PID_KEY] || 0,
        },
        {
          label: "UnknownMax",
          value: apiData[MAX_PID_KEY] || 0,
        },
      ],
      startStopSettings: [
        { label: "Compressor SD on Well SD", value: apiData[config.COMP_SD] },
        { label: "Mandatory Shutin SD", value: apiData[config.MAND_SHUTIN_SD] },
      ],
      timedIncrementalSettings: [
        {
          label: "Automatic SP",
          value: apiData[config.AUTO_SP],
          measurement: "MCF",
        },
        {
          label: "Casing PSI (Actual)",
          value: apiData[config.CASING_ACTUAL],
          measurement: "PSI",
        },
        {
          label: "Casing PSI (@Time of Sample)",
          value: apiData[config.CASING_TIME_SAMPLE],
          measurement: "PSI",
        },
        {
          label: "Sample Time SP",
          value: apiData[config.SAMPLE_TIME],
          measurement: "MIN",
        },
        {
          label: "Sample Deadband",
          value: apiData[config.SAMPLE_DEADBAND],
          measurement: "PSI",
        },
        {
          label: "Setpoint Increment Value",
          value: apiData[config.SETPOINT_INC_VAL],
          measurement: "PSI",
        },
        {
          label: "Setpoint Decrement Value",
          value: apiData[config.SETPOINT_DEC_VAL],
          measurement: "PSI",
        },
        {
          label: "Minimum Allowed Flow Rate",
          value: apiData[config.MIN_FLOW_RATE],
          measurement: "",
        },
        {
          label: "Maximum Allowed Flow Rate",
          value: apiData[config.MAX_FLOW_RATE],
          measurement: "",
        },
      ],
      analogSetpointsSettings: [
        {
          title: "Flow Rate Mode Setpoints",
          fields: [
            {
              label: "Flow Rate Automatic SP",
              value: apiData[config.AUTO_SP],
              unit: "MCF",
            },
            {
              label: "Flow Rate Deadband SP",
              value: apiData[config.FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
          ],
        },
        {
          title: "Casing PID Setpoints",
          fields: [
            {
              label: "Casing PID Automatic SP",
              value: apiData[config.CASING_PID_AUTO_SP],
              unit: "PSI",
            },
            {
              label: "Casing PID Deadband SP",
              value: apiData[config.CASING_PID_DEADBAND_SP],
              unit: "PSI",
            },
          ],
        },
        {
          title: "Tubing:Casing Ratio Setpoints",
          fields: [
            {
              label: "Tubing : Casing SP",
              value: apiData[config.TUBING_CASING_SP],
              unit: "%",
            },
            {
              label: "Tubing : Casing Debounce",
              value: apiData[config.TUBING_CASING_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Shutin Resets",
              value: apiData[config.MAX_SHUTIN_RESET],
              unit: "",
            },
            {
              label: "Plunger Fall Timer",
              fields: {
                hrs: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[0]] || 0,
                ),
                min: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[1]] || 0,
                ),
                sec: PRC_WELL.formatHours(
                  apiData[config.PLG_FALL_TIMER?.[2]] || 0,
                ),
              },
              unit: "",
            },
          ],
          toBeEnabled: "Tubing : Casing",
          disabledText: "Tubing:Casing Optimization - Disabled",
        },
        {
          title: "Critical Flow Rate Setpoints",
          fields: [
            {
              label: "Critical Flow Rate SP",
              value: apiData[config.CRITICAL_FLOW_RATE_SP],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Deadband",
              value: apiData[config.CRITICAL_FLOW_RATE_DEADBAND],
              unit: "MCF",
            },
            {
              label: "Critical Flow Rate Debounce",
              value: apiData[config.CRITICAL_FLOW_RATE_DEBOUNCE],
              unit: "SEC",
            },
            {
              label: "Maximum Afterflow Resets",
              value: apiData[config.MAX_AFTERFLOW_RESET],
              unit: "",
            },
          ],
          toBeEnabled: "Critical Flow Rate",
          disabledText: "Critical Flow Rate Optimization - Disabled",
        },
        {
          title: "Casing Rise Setpoints",
          fields: [
            {
              label: "Casing Rise SP",
              value: apiData[config.CASING_RISE_SP],
              unit: "PSI",
            },
            {
              label: "Casing Rise Debounce",
              value: apiData[config.CASING_RISE_DEBOUNCE],
              unit: "SEC",
            },
          ],
          toBeEnabled: "Casing Rise",
          disabledText: "Casing Rise Optimization - Disabled",
          fullWidth: true,
        },
      ],
    },
  };
};

export const handleGetPlgSDSPSetpointsBtn = async (
  unitId,
  registerList,
  cmd,
  setProgressSuccess,
  setProgressError,
  setProgressOpen,
) => {
  let pollInterval = null;

  const stopPolling = () => {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  };

  const pollForChange = ({
    lastTime,
    durationMs,
    intervalMs,
    onSuccess,
    onTimeout,
  }) => {
    const start = Date.now();

    pollInterval = setInterval(async () => {
      try {
        const resp = await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
          registerList,
        );

        const { time: currentTime } = resp.data.data || {};

        const timeChanged =
          currentTime && Number(currentTime) !== Number(lastTime);

        console.log("⏳ Polling...", { lastTime, currentTime });

        if (timeChanged) {
          stopPolling();
          onSuccess({
            currentTime,
          });
          console.log("🔄 Device time changed:", lastTime, "->", currentTime);
        }

        if (Date.now() - start >= durationMs) {
          stopPolling();
          onTimeout();
        }
      } catch (err) {
        console.warn("Polling error:", err.message);
      }
    }, intervalMs);
  };
  try {
    const initialResp = await axios.post(
      `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
      registerList,
    );
    let lastTime = Number(initialResp.data.data?.time || 0);
    console.log("Initial time:", lastTime);
    // Send P
    await axios.post(
      `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
      { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`, },
      { headers: { id: "anything", "Content-Type": "application/json" } },
    );
    console.log("🟢 P command sent, polling...");
    // Poll AFTER P
    pollForChange({
      unitId,
      registerList,
      lastTime,
      durationMs: 170000,
      intervalMs: 4000,

      onSuccess: () => {
        console.log("✅ Update done after P command");
        setProgressSuccess(true);
      },

      onTimeout: () => {
        console.warn("❌ Timeout after P command");
        setProgressError(
          "⏰ Timeout waiting for device response. Please try again.",
        );
      },
    });
  } catch (err) {
    console.error("❌ get plunger SD Setpoints failed:", err);
    setProgressError("Failed to retrieve plunger SD Setpoints.");
    setProgressOpen(false);
  }
};

export const getPlgSDSPSetpointsBtn = async (
  unitId,
  regList,
  pCommand,
  setProgressSuccess,
  setProgressError,
  setProgressOpen,
) => {
  try {
    const confirmed = window.confirm(
      "Please confirm you want to pull Plunger SD Setpoints",
    );
    if (!confirmed) return;

    const wellType = await getWellsFromAPI(unitId);

    // Step 1: Open dialog
    setProgressOpen(true);
    setProgressSuccess(false);

    // Step 2: Wait a short delay to allow UI to render
    setTimeout(async () => {
      if (wellType?.type === "WellPro II") {
        await handleGetPlgSDSPSetpointsBtn(
          unitId,
          regList,
          pCommand,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
        return;
      } else {
        await handleGetPlgSDSPSetpointsBtn(
          unitId,
          regList,
          pCommand,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
      }
    }, 100);
  } catch (err) {
    console.error("❌ get plunger SD Setpoints failed:", err);
    setProgressError("Failed to retrieve plunger SD Setpoints.");
    setProgressOpen(false);
  }
};
